module.exports = __webpack_public_path__ + "static/img/logo.569cfc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 29
// module chunks = 1 2 3 4 5 6 7 8 9 10 11